import {
    type ContractVariant as FilterCell,
    filterContract,
} from 'aos-ds/src/primitives/filter/filter.contract'
import {
    type ContractVariant as CollapsedCell,
    filterswitchCollapsedContract,
} from 'aos-ds/src/primitives/filterswitch-collapsed/filterswitch-collapsed.contract'
import {
    type ContractVariant as TriggerCell,
    filterswitchTriggerContract,
} from 'aos-ds/src/primitives/filterswitch-trigger/filterswitch-trigger.contract'
import { variantForStyleId } from 'aos-ds/src/typography/variants'

type FilterSelection = (typeof filterContract.props.selection.values)[number]
type FilterType = (typeof filterContract.props.type.values)[number]

export const LABEL_VARIANT = variantForStyleId(filterContract.textStyleIds[0])

const filterVariantKey = (selection: FilterSelection, type: FilterType): string =>
    `selection=${selection}, type=${type}`

export const resolveFilter = (selection: FilterSelection, type: FilterType): FilterCell => {
    const key = filterVariantKey(selection, type)
    const cell = (filterContract.variants as Record<string, FilterCell>)[key]
    if (!cell) {
        throw new Error(`FilterSwitchRow: the Filter contract has no "${key}"`)
    }
    return cell
}

export const resolveTrigger = (open: boolean): TriggerCell => {
    const key = `open=${open}`
    const cell = (filterswitchTriggerContract.variants as Record<string, TriggerCell>)[key]
    if (!cell) {
        throw new Error(`FilterSwitchRow: the FilterSwitch/Trigger contract has no "${key}"`)
    }
    return cell
}

export const resolveCollapsed = (open: boolean): CollapsedCell => {
    const key = `open=${open}`
    const cell = (filterswitchCollapsedContract.variants as Record<string, CollapsedCell>)[key]
    if (!cell) {
        throw new Error(`FilterSwitchRow: the FilterSwitch/Collapsed contract has no "${key}"`)
    }
    return cell
}
